import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = (theme) => ({
  noData: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  noDataText: {
    fontSize: "16px",
    lineHeight: "22px",
    color: theme.iconColor,
  },
});

const NoData = ({ classes, dataUpdateInProgress }) => {
  return (
    <div className={classes.noData}>
      <div className={classes.centerText}>
        {dataUpdateInProgress ? (
          <CircularProgress size={40} />
        ) : (
          <div className={classes.noDataText}>No data available</div>
        )}
      </div>
    </div>
  );
};
export default compose(withStyles(styles))(NoData);
